import axios from 'axios';

const catalogApiClient = axios.create({
  baseURL: process.env.REACT_APP_CATALOG_API_PATH,
});

export default catalogApiClient;
